// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询 HQ 后台账号 GET /api/v1/hq/staff */
export async function HqStaffControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStaffDtoArray>("/api/v1/hq/staff", {
    method: "GET",
    params: {
      // pageSize has a default value: 10
      pageSize: "10",

      // logicOperator has a default value: and
      logicOperator: "and",

      // sortOrder has a default value: DESC
      sortOrder: "DESC",

      ...params,
    },
    ...(options || {}),
  });
}

/** 邀请 HQ 后台账号 POST /api/v1/hq/staff */
export async function HqStaffControllerInviteV1(
  body: MyApi.InviteStaffDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStaffDto>("/api/v1/hq/staff", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** HQ 后台账号详情 GET /api/v1/hq/staff/${param0} */
export async function HqStaffControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/hq/staff/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新 HQ 后台账号 PUT /api/v1/hq/staff/${param0} */
export async function HqStaffControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerUpdateV1Params,
  body: MyApi.UpdateStaffDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/hq/staff/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 移除 HQ 后台账号 DELETE /api/v1/hq/staff/${param0} */
export async function HqStaffControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(`/api/v1/hq/staff/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 分配 HQ 后台账号角色 PUT /api/v1/hq/staff/${param0}/roles */
export async function HqStaffControllerAssignRolesV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerAssignRolesV1Params,
  body: MyApi.AssignStaffRolesDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/hq/staff/${param0}/roles`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 启用/停用 HQ 后台账号 PUT /api/v1/hq/staff/${param0}/status */
export async function HqStaffControllerSetStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.HqStaffControllerSetStatusV1Params,
  body: MyApi.SetStaffStatusDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/hq/staff/${param0}/status`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
